import { render, staticRenderFns } from "./TabShareLandingPage.vue?vue&type=template&id=61969e88&"
import script from "./TabShareLandingPage.vue?vue&type=script&lang=js&"
export * from "./TabShareLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports